var site = site || {};

(function($) {
  "use strict";
  Drupal.behaviors.bfeed_insta = {
    attach: function(context, settings) {

      // See bf_massrel.js
      var $socialBlock = $('#social-content--instagram');

      site.bf_massrel.massrel_render(
        $socialBlock.data('massrel-feed'), // feed id
        $socialBlock, // actual element
        tweakData // calllback url to tweak data
//        postRenderInsta // postRender callback for instagram
      );

      function postRenderInsta(data) {
      }

      // Custom clean our data if need be
      function tweakData(data) {
        _.map(data, function(post) {
          // instagram dates are unix timestamps
          var instaDate = new Date(post.created_time * 1000);
          // time ago
          post.el_ago = $.timeago(instaDate);

          return post;
        });

        return {mass_rel: data};
      }
    }
  };
})(jQuery);
